import React, { useState } from 'react';
import './staking.css';

const StakingDetail = () => {
    const [expandedMenu, setExpandedMenu] = useState('Guide for Beginners');
    const [expandedSubMenu, setExpandedSubMenu] = useState(null);
    const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

    const toggleMenu = (menu) => {
        setExpandedMenu(expandedMenu === menu ? null : menu);
        setExpandedSubMenu(null);
    };

    const toggleSubMenu = (menu) => {
        setExpandedSubMenu(expandedSubMenu === menu ? null : menu);
    };

    const helpCenterData = {
        "Guide for Beginners": [
            {
                name: "Registration",
                articles: [
                    "How to Register (Web)", "How to Register (App)", "Registration FAQ",
                    "Creating a Corporate Account", "Troubleshooting Registration Errors",
                    "Email Verification Issues", "Mobile Verification Issues",
                    "Forgot Password Steps", "Changing Email Address", "Account Lock Reasons"
                ]
            },
            {
                name: "Security Setup",
                articles: [
                    "How to Setup 2FA", "Account Security Best Practices", "Changing Login Password",
                    "Binding Google Authenticator", "Anti-Phishing Code Setup",
                    "Managing Authorized Devices", "Disabling SMS Authentication",
                    "Enabling Face ID / Touch ID", "Resetting Security Settings", "What is a Fund Password"
                ]
            },
            {
                name: "Basic Trading",
                articles: [
                    "How to Buy Crypto with Fiat", "Basic Trading FAQ", "Understanding Market Orders",
                    "Understanding Limit Orders", "How to read the Order Book",
                    "What are Trading Fees", "Withdrawing Crypto Basics",
                    "Depositing Crypto Basics", "Using the Convert Feature", "Tracking your Portfolio"
                ]
            }
        ],
        "P2P Trade": [
            {
                name: "How to Buy Crypto",
                articles: [
                    "P2P Buying Guide (Web)", "P2P Buying Guide (App)", "Choosing a P2P Merchant",
                    "Payment Methods for P2P", "Handling Payment Delays",
                    "P2P Escrow Explained", "Contacting P2P Counterparty"
                ]
            },
            {
                name: "How to Sell Crypto",
                articles: [
                    "P2P Selling Guide (Web)", "P2P Selling Guide (App)", "Receiving Funds Securely",
                    "Setting up P2P Payment Methods", "Avoiding P2P Scams",
                    "Releasing Crypto Safely", "Adding a Bank Account"
                ]
            },
            {
                name: "P2P Appeals",
                articles: [
                    "How to file an appeal", "Appeal Rules", "What evidence is required",
                    "Appeal processing time", "Handling uncooperative buyers",
                    "Cancelling an appeal", "Customer Support Role in Appeals"
                ]
            }
        ],
        "Spot & Margin": [
            { 
                name: "Spot", 
                articles: [
                    "Spot Trading Guide", "Spot FAQ", "Advanced Charting Tools", 
                    "Understanding Trading Pairs", "Spot Wallet vs Funding Wallet", 
                    "Stop-Limit Order Guide", "OCO Order Guide"
                ] 
            },
            { 
                name: "Margin Trading", 
                articles: [
                    "Margin Guide", "Margin Rules", "Cross vs Isolated Margin",
                    "How to Borrow Funds", "How to Repay Loans",
                    "Understanding Liquidation", "Margin Interest Rates",
                    "Transferring to Margin Account", "Margin Call Explained"
                ] 
            },
            { 
                name: "Stocks", 
                articles: [
                    "Stock Token Guide", "Dividend Distribution", "Stock Token Trading Hours",
                    "Corporate Actions", "Stock Token Risks", "Available Stock Tokens"
                ] 
            },
            { 
                name: "Entrusted Transaction", 
                articles: [
                    "Entrusted Guide", "What is Entrusted Trading", "Setting Entrusted Parameters",
                    "Canceling Entrusted Orders", "Entrusted Fees", "Common Errors in Entrusted"
                ] 
            }
        ],
        "ETF": [
            { 
                name: "Novice Guide", 
                articles: [
                    "ETF Beginner's Guide", "What is a Leveraged ETF?", "Rebalancing Mechanism",
                    "ETF Risks", "Why ETF Net Value Decays", "ETF vs Margin Trading"
                ] 
            },
            { 
                name: "Functional Guidelines", 
                articles: [
                    "ETF Rules", "ETF Fees", "Funding Rates for ETF",
                    "ETF Merges", "How to Trade ETFs", "Historical Net Value"
                ] 
            }
        ],
        "Unified Account": [
            { 
                name: "Unified Account Overview", 
                articles: [
                    "What is Unified Account", "Upgrading to Unified Account", "Unified Account Features",
                    "Multi-Currency Margin", "Auto-Borrowing Feature", "Supported Assets"
                ] 
            },
            { 
                name: "Risk Control Mechanism", 
                articles: [
                    "Risk Control FAQ", "Account Maintenance Margin Rate", "Initial Margin Rate",
                    "Liquidation Process in Unified Account", "Stress Testing Models", 
                    "Managing Risk in Unified Account", "Margin Call Alerts"
                ] 
            }
        ],
        "Futures": [
            { 
                name: "Novice Guide", 
                articles: [
                    "Futures Beginner's Guide", "What are Crypto Futures?", "Long vs Short",
                    "Understanding Leverage", "Funding Fees Explained", "Futures Glossary"
                ] 
            },
            { 
                name: "Know-Hows in Futures...", 
                articles: [
                    "Advanced Futures", "Hedging Strategies", "Grid Trading for Futures",
                    "API Trading for Futures", "Using TP/SL effectively", 
                    "Trailing Stop Orders", "TWAP and VWAP Orders"
                ] 
            },
            { 
                name: "Perpetual Futures", 
                articles: [
                    "Perpetual Guide", "USDT-M vs Coin-M Futures", "Mark Price vs Index Price",
                    "Funding Rate Calculations", "Settlement Rules", "ADL (Auto-Deleveraging)"
                ] 
            },
            { 
                name: "Delivery Futures", 
                articles: [
                    "Delivery Guide", "Quarterly Delivery Futures", "Bi-Weekly Delivery Futures",
                    "Delivery Settlement Price", "Rolling over contracts", "Delivery Fees"
                ] 
            }
        ],
        "TradFi": [
            { 
                name: "What is TradFi", 
                articles: [
                    "TradFi Introduction", "Bridging TradFi and DeFi", "Institutional Grade Custody",
                    "TradFi Security Standards", "Compliance and KYC for TradFi"
                ] 
            },
            { 
                name: "TradFi Products", 
                articles: [
                    "Product List", "Treasury Bills", "Tokenized Bonds",
                    "Yield Generation", "Redemption Process", "Product Risk Disclosures"
                ] 
            }
        ],
        "Copy Trading": [
            { 
                name: "Lead Trader Guide", 
                articles: [
                    "How to be a Lead Trader", "Profit Sharing Rules", "Managing your Followers",
                    "Lead Trader Requirements", "Setting Trading Strategies", 
                    "Lead Trader Badges and Tiers", "Withdrawing Profit Shares"
                ] 
            },
            { 
                name: "Copier Guide", 
                articles: [
                    "How to Copy Trades", "Choosing the right Lead Trader", "Setting Copy Trading Limits",
                    "Stopping a Copy Trade", "Copier Risk Management", "Viewing Copy Trade History"
                ] 
            }
        ],
        "CFD Copy Trading": [
            { 
                name: "CFD Guidelines", 
                articles: [
                    "CFD Overview", "CFD vs Spot Trading", "CFD Leverage Explained",
                    "Overnight Fees", "CFD Margin Requirements", "CFD Asset Classes"
                ] 
            },
            { 
                name: "CFD Rules", 
                articles: [
                    "Trading Rules", "CFD Settlement", "Dividend Adjustments in CFD",
                    "CFD Market Hours", "CFD Order Types", "Resolving CFD Disputes"
                ] 
            }
        ],
        "Community Interaction": [
            { 
                name: "Posts", 
                articles: [
                    "How to Post", "Content Guidelines", "Earning Rewards for Posts",
                    "Reporting Inappropriate Content", "Following other Users", "Using Hashtags"
                ] 
            },
            { 
                name: "Chat Room", 
                articles: [
                    "Chat Rules", "Joining Chat Rooms", "Sending Red Packets in Chat",
                    "Direct Messaging", "Chat Room Moderation", "Muting Users"
                ] 
            },
            { 
                name: "Live Streaming", 
                articles: [
                    "Live Stream Guide", "How to become a Streamer", "Viewer Interaction Guidelines",
                    "Gifting during Streams", "Streamer Monetization", "Live Stream Schedule"
                ] 
            }
        ],
        "Earn": [
            { 
                name: "Crypto Loan", 
                articles: [
                    "Fixed-Term Loan Limited-Time Interest Rate Reduction - Campaign Rules",
                    "FAQ on Fixed Rate Loan",
                    "Introduction of Multi-Collateral Loans",
                    "About Flexible Crypto Loan",
                    "Flexible Crypto Loan Guide",
                    "About Fixed Crypto Loan",
                    "Crypto Loan Liquidation Rules",
                    "Loan Repayment Terms"
                ] 
            },
            { 
                name: "Auto-Investment", 
                articles: [
                    "What is Auto- Investment (Comics)",
                    "Auto-Investment Instructions (App)",
                    "Auto-Invest User Guide (Web)",
                    "What Is Periodic Investment Plan",
                    "Editing an Auto-Invest Plan",
                    "Pausing or Canceling Auto-Invest",
                    "Auto-Invest Supported Coins"
                ] 
            },
            { 
                name: "Soft Staking", 
                articles: [
                    "How to participate in AGCX Soft Staking (App)",
                    "How to participate in AGCX Soft Staking (Web)",
                    "Soft Staking FAQ",
                    "Introduction to Soft Staking",
                    "Soft Staking Reward Calculation",
                    "Supported Soft Staking Assets"
                ] 
            },
            { 
                name: "Dual Investment", 
                articles: [
                    "Dip Sniper & Peak Sniper FAQ",
                    "AGCX Dual Investment & USDT Buy-Low-to-Earn Strategy",
                    "Dual-Invest Auto-Reinvest Feature",
                    "Dual-Investment Operation Instructions",
                    "Dual Investment — FAQ",
                    "Dual Investment User Guide (App)",
                    "About Dual Investment",
                    "Dual Investment User Guide (Web)",
                    "Dual Investment Risk Warning"
                ] 
            },
            { 
                name: "Simple Earn", 
                articles: [
                    "Simple Earn Introduction",
                    "How to use Simple Earn",
                    "Simple Earn FAQ",
                    "Flexible vs Locked Earn",
                    "Simple Earn Auto-Subscribe Feature",
                    "Early Redemption Rules"
                ] 
            },
            { 
                name: "Quant Fund", 
                articles: [
                    "Quant Fund Overview",
                    "How to Invest in Quant Funds",
                    "Quant Fund Returns Calculation",
                    "Quant Fund Lock-up Periods",
                    "Quant Fund Management Fees",
                    "Quant Fund Historical Performance"
                ] 
            },
            { 
                name: "Staking", 
                articles: [
                    "Standard Redemption Cancellation Process for On-Chain Earn",
                    "What is GUSD? (Video)",
                    "Staking Video Introduction",
                    "AGCX Earn Staking — GUSD Minting and RWA Analysis",
                    "How to Check Order Status and Earnings When Earning Tokens on AGCXChain (App Version)",
                    "How to Redeem Assets in AGCX Earn on AGCXChain (Web Version)",
                    "How to Redeem On-Chain Earn Assets on AGCe (App Version)",
                    "How to Check On-Chain Earn Order Status and Earnings on AGCX (Web Version)",
                    "Staking User Guide (App)",
                    "Staking User Guide (Web Version)",
                    "PoS Staking Rewards Distribution"
                ] 
            },
            { 
                name: "Smart Leverage", 
                articles: [
                    "Smart Leverage User Guide",
                    "Smart Leverage FAQ",
                    "Understanding Smart Leverage Risks",
                    "Smart Leverage Fees and Charges",
                    "When to use Smart Leverage",
                    "Smart Leverage Maximum Position Limits"
                ] 
            },
            { 
                name: "Auto-Invest", 
                articles: [
                    "Auto-Invest Plan Tutorial",
                    "How to manage Auto-Invest Portfolio",
                    "Auto-Invest FAQ",
                    "Index-Linked Auto-Invest Plans",
                    "Auto-Invest ROI Calculation",
                    "Using Credit Card for Auto-Invest"
                ] 
            }
        ]
    };

    const currentRightSideData = helpCenterData[expandedMenu] || [];

    return (
        <div className="staking_detail_wrapper">
            <div className="container">
                <div className="hc_breadcrumb">
                    <span className="hc_link">Help Center</span> <span className="hc_sep">&gt;</span> <span className="hc_current">FAQ</span>
                </div>
                
                <div className="hc_layout">
                    {/* Mobile Sidebar Toggle */}
                    <div className="hc_mobile_toggle" onClick={() => setMobileSidebarOpen(!mobileSidebarOpen)}>
                        <h2>Categories</h2>
                        <span className={`hc_section_chev ${mobileSidebarOpen ? 'open' : ''}`}>
                            <svg viewBox="0 0 16 16" width="16" height="16" fill="currentColor" stroke="currentColor" strokeWidth="1"><path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg>
                        </span>
                    </div>

                    {/* Sidebar */}
                    <div className={`hc_sidebar ${mobileSidebarOpen ? 'mobile_open' : ''}`}>
                        {Object.keys(helpCenterData).map((menuName, idx) => (
                            <div key={idx}>
                                <div className="hc_sidebar_item" onClick={() => { toggleMenu(menuName); setMobileSidebarOpen(false); }}>
                                    <span className={expandedMenu === menuName ? 'font-weight-bold text-black' : ''}>{menuName}</span>
                                    <span className={`hc_chev ${expandedMenu === menuName ? 'open' : ''}`}>
                                        <svg viewBox="0 0 16 16" width="12" height="12" fill="currentColor"><path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg>
                                    </span>
                                </div>
                                {expandedMenu === menuName && (
                                    <div className="hc_submenu">
                                        {helpCenterData[menuName].map((sub, sIdx) => (
                                            <div 
                                                key={sIdx} 
                                                className={`hc_submenu_item ${expandedSubMenu === sub.name ? 'active_sub' : ''}`}
                                                onClick={(e) => { e.stopPropagation(); toggleSubMenu(sub.name); }}
                                            >
                                                {sub.name}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* Main Content */}
                    <div className="hc_main_content">
                        {currentRightSideData.map((section, idx) => (
                            <div key={idx} className="hc_content_section">
                                <div className="hc_section_header" onClick={() => toggleSubMenu(section.name)}>
                                    <h2>{section.name}</h2>
                                    <span className={`hc_section_chev ${expandedSubMenu === section.name ? 'open' : ''}`}>
                                        <svg viewBox="0 0 16 16" width="16" height="16" fill="currentColor" stroke="currentColor" strokeWidth="1"><path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg>
                                    </span>
                                </div>
                                
                                {expandedSubMenu === section.name && (
                                    <div className="hc_article_grid">
                                        {section.articles.map((article, aIdx) => (
                                            <div key={aIdx} className="hc_article_item">
                                                <a href="#/">{article}</a>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StakingDetail;
